module.exports = __webpack_public_path__ + "img/startnow.95eedd7.jpg";